import { QueryClient } from "@tanstack/react-query";

/**
 * 設定済みのQueryClientインスタンスを作成する
 *
 * 使用箇所:
 * - App.tsx（本番環境）
 * - テストヘルパー（テスト環境）
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // テスト時はリトライしない
        retry: process.env.NODE_ENV === "test" ? false : 3,
        // 再フェッチまでの古さ許容時間
        staleTime: 1000 * 60, // 1分
        // ガベージコレクションまでのキャッシュ時間
        gcTime: 1000 * 60 * 5, // 5分
        // 本番環境のみウィンドウフォーカス時に再フェッチ
        refetchOnWindowFocus: process.env.NODE_ENV === "production",
      },
      mutations: {
        // ミューテーションはリトライしない
        retry: false,
      },
    },
  });
}

/**
 * アプリケーション用のシングルトンQueryClient
 */
export const queryClient = createQueryClient();
